import { getArticlesSuggestions, learningCenter } from 'constants/routes';

/**
 * Generates the URL for an article based on the provided article suggestion.
 * @param {HTMLElement} articleSuggestion - The suggestion containing information about the article.
 * @returns {string} The generated URL for the article.
 */
export const getArticlePageUrl = function(articleSuggestion){
  const { articleUrl } = articleSuggestion.dataset;
  return articleUrl;
};

/**
 * Constructs the URL for fetching article suggestions based on the provided content client.
 * @param {string} contentClient - The identifier for the content client to be used in the request.
 * @returns {string} The constructed URL with the encoded content client parameter.
 */
export const getArticleSuggestionsUrl = function(contentClient) {
  if(!contentClient) {return getArticlesSuggestions;}
  return `${getArticlesSuggestions}?contentClient=${encodeURIComponent(contentClient)}`
};

/**
 * Generates the URL for the search results page based on the provided search term and optional page parameter.
 * @param {string} searchTerm - The term to search for.
 * @param {string} [contentClientParameter] - An optional parameter indicating the content client.
 * @returns {string} The constructed URL for the search results page.
 */
export const getArticleSearchResultPageUrl = function(searchTerm, contentClientParameter) {
  const contentClient = contentClientParameter ? `&contentClient=${encodeURIComponent(contentClientParameter)}` : '';
  const url = `${learningCenter}/page-1/?searchTerm=${encodeURIComponent(searchTerm)}${contentClient}`;
  return url;
};